import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';
import type { AttentionList } from '../../model/attention.js';
import { attentionQueries } from '../queries/attention-queries.js';
import { dismissAttention } from '../requests/dismiss-attention.js';

const withoutItem = (list: AttentionList, id: string): AttentionList => ({
  today: list.today,
  items: list.items.filter((item) => item.id !== id),
});

export const useDismissAttentionMutation = (): UseMutationResult<void, Error, string> => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: dismissAttention,
    onSuccess: async (_nothing, id) => {
      queryClient.setQueryData(attentionQueries.list().queryKey, (list) =>
        list === undefined ? undefined : withoutItem(list, id),
      );
      await queryClient.invalidateQueries({ queryKey: attentionQueries.all() });
    },
  });
};
